export const passportNumberPipe = (data?: string): string => {
  if (!data) {
    return '';
  }
  return data.replace(new RegExp(/(\d{4})(\d{6})/), '$1 $2');
};
